import { AdminSettingsScreen } from 'modules/admin/screens/AdminSettingsScreen'

export const AdminSettingsPage = () => {
  /* --- Section 6: Render --- */
  return <AdminSettingsScreen />
}
